/** Iniciales para el avatar: «Javier Rapiós» → «JR», «Omar» → «OM». Puro (vale en el navegador). */
export function inicialesDe(nombre: string): string {
  const palabras = nombre.trim().split(/\s+/).filter(Boolean);
  if (!palabras.length) return "?";
  const dos = palabras.length === 1 ? palabras[0].slice(0, 2) : palabras[0][0] + palabras[palabras.length - 1][0];
  return dos.toUpperCase();
}
